module.exports = __webpack_public_path__ + "static/media/tickWhite.62acc2d7.svg";